//import Vue from 'vue'
import {createStore} from 'vuex'
import user from './modules/user'
import events from './modules/events'
import requests from './modules/requests'
import settings from './modules/settings'
import terminals from './modules/terminals'
import customers from './modules/customers'
import {markRaw} from "vue"
//Vue.use(Vuex);

//const debug = process.env.NODE_ENV !== 'production'

export const store = createStore({
    state: {
        popupOpened: false,
        popupComponent: false,
        popupData: {},
        loading: false,
        firstLoading: false,
        notifications: [
           /* {
                message: "The event has been deleted",
                type: "success",
                interval: 3,
            },
            {
                message: "Error",
                type: "error",
                interval: 4,
            },
            {
                message: "Warning",
                type: "warning",
                interval: 5,
            },
            {
                message: "Notification message",
                type: "notification1",
                interval: 6,
            },
            {
                message: "Notification message 2",
                type: "notification2",
                interval: 7,
            },*/
        ]
    },
    mutations: {
        switchPopup (state, value) {
            state.popupOpened = value;
            let root = document.getElementsByTagName( 'html' )[0];
            if (value) {
                root.classList.add('opened-popup')
            } else {
                state.popupComponent = false;
                root.classList.remove('opened-popup')
            }
        },
        setPopupComponent (state, component) {
            state.popupComponent = markRaw(component);
        },
        setPopupData (state, data) {
            state.popupData = data;
        },
        pushNotification (state, item) {
            state.notifications.push(item);
        },
        closeNotification (state, index) {
            state.notifications.splice(index, 1);
        },
        setLoading (state, value) {
            let html = document.getElementsByTagName('html')[0];
            if (!state.loading && value) {
                html.classList.add("overlay-loader-visible")
                console.log('visible')
                state.loading = value;
            } else if (state.loading && !value)  {
                if (!state.firstLoading) {
                    state.loading = value;
                    console.log('hide')
                    html.classList.remove("overlay-loader-visible")
                }
            }
        },
        setFirstLoading (state, value) {
            state.firstLoading = value;
        },
        /*setStatus (state, value) {
            state.statusText = value
        },
       */
    },
    actions: {
        /*sendArrestPlace({commit}, params) {
            return new Promise((resolve) => {

            });
        },*/
    },
    modules: {
        user,
        events,
        settings,
        terminals,
        customers,
        requests
    },
    /*getters : {

    }*/
    //strict: debug,
    //plugins: debug ? [createLogger()] : []
})